import { useContext } from 'react'

import { UserFormContext, UserFormData } from '@/contexts/userForm'
import { useGeneralErrors } from '@/hooks/useGeneralErrors'
import { User } from '@/types/user'

interface UseUserFormProps {
  getUserDataById: (id: string) => UserFormData
  clearData: () => void
  addData: (id: string, value: UserFormData) => void
  getUserData: () => User['data']
  clearDataById: (id: string) => void
}

export const useUserForm = (): UseUserFormProps => {
  const { userForm, setUserForm } = useContext(UserFormContext)
  const { clearGeneralErrors } = useGeneralErrors()

  const addData = (id: string, value: UserFormData) => {
    clearGeneralErrors()
    setUserForm((prev) => ({
      ...prev,
      [id]: value
    }))
  }

  const clearData = () => {
    setUserForm(null)
  }

  const clearDataById = (id: string) => {
    setUserForm((prev) => ({
      ...prev,
      [id]: undefined
    }))
  }

  const getUserData = (): User['data'] => {
    return userForm as User['data']
  }

  const getUserDataById = (id: string): UserFormData => {
    return userForm ? userForm[id] : undefined
  }

  return {
    getUserDataById,
    clearData,
    addData,
    getUserData,
    clearDataById
  }
}
